import * as OAuth from "oauth2";
import * as Messenger from "service-worker/es/messenger";

export { sendAuth } from "service-worker/es/oauth/app";

export const onMessage = async (event: MessageEvent<any>) => {
  if (event.data?.type === "OAUTH_REFRESH_AUTH") {
    const refreshed = await OAuth.refreshAuth(false, {
      headers: {
        "sw-refresh-auth-from-sw-request": "true",
      },
    });
    const auth = {
      token: OAuth.constructAccessToken(refreshed.token),
      user: refreshed.user,
    };
    Messenger.answerMessage(event, auth);
  } else if (event.data?.type === "OAUTH_DECONNECT") {
    OAuth.deconnect();
  }
};
